import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useGetCartQuery} from '@/services/api/cart-api';
import {useTranslation} from '@/services/i18n/hooks/useTranslation';

const ProductInCartCount = ({sku, cartId, className, ...restProps}) => {
  const {data: cart} = useGetCartQuery(cartId, {skip: !cartId});
  const {t} = useTranslation();

  const countInCart = useMemo(() => {
    if (!sku || !cart || !cart.lineItems) return 0;

    const item = cart.lineItems.find((item) => item.materialNumber === sku);
    return item?.quantity ?? 0;
  }, [cart, sku]);

  if (countInCart === 0) return null;

  const labelKey = countInCart > 1 ? 'ecomm.product.items_in_cart_label' : 'ecomm.product.item_in_cart_label';
  return (
    <span className={`text-green font-size--2 ${className || ''}`} {...restProps}>
      {t(labelKey, countInCart)}
    </span>
  );
};

ProductInCartCount.propTypes = {
  sku: PropTypes.string.isRequired,
  cartId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ProductInCartCount;
